import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@Sage/hoi-poi-ui';

import SearchList from 'containers/components/SearchList';
import { CAMPAIGNS_TEMPLATES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';

import { MARKETING_TEMPLATES_PATHS } from '../../marketingTemplatesPaths';

import './styles.scss';

const TemplatesListMenu = memo(() => {
    const navigate = useNavigate();

    const handleCreateTemplate = useCallback(() => {
        navigate(MARKETING_TEMPLATES_PATHS.NEW_SELECTOR);
    }, [navigate]);

    return (
        <div className="fm-entity-menu marketing-templates-list-menu">
            <div className="fm-entity-menu-left marketing-templates-list-menu__left">
                <div className="marketing-templates-list-menu__search">
                    <SearchList
                        className="marketing-templates-list-menu__search-list"
                        entity={CAMPAIGNS_TEMPLATES}
                        placeholder={getLiteral('label_marketing_campaigns_templates_search')}
                        useAsSimpleSearch
                    />
                </div>
            </div>
            <div className="fm-entity-menu-right marketing-templates-list-menu__right">
                <div className="fm-entity-action add-button-container">
                    <Button size="medium" onClick={handleCreateTemplate}>
                        {getLiteral('label_marketing_campaigns_templates_create_template')}
                    </Button>
                </div>
            </div>
        </div>
    );
});

TemplatesListMenu.displayName = 'TemplatesListMenu';

export default TemplatesListMenu;
